export enum ControllerBulkAction {
  replace_configuration = 'replace_configuration',
}

export interface ControllerDescription {
  id: string
  /*
   * Equipment number is optional to potentially allow future cloud controllers to be represented as controllers.
   * It would be harder to retroactively make things optional.
   */
  equipmentNumber?: number
  /**
   * A controller may have been given a human-friendly name, or maybe not
   */
  label?: string
  createdAt: string
  updatedAt: string
  siteId?: string
  /** Absent when served by a Device Manager version that predates it */
  currentFirmware?: ControllerFirmware | null
}

export type RootFirmware = {
  version: string | null
}

export type PackageFirmware = {
  packageName: string | null
  version: string | null
}

/** Firmware versions the controller reported at its last boot */
export type ControllerFirmware = {
  root: RootFirmware
  jvm: PackageFirmware
  app: PackageFirmware
}

export interface ControllerListIdentifier {
  equipmentNumber?: number
  id?: string
  /** The value as entered by the user, either of the above */
  rawValue: string
}

export interface SelectableController {
  controller: ControllerDescription
  isSelected: boolean
}

export interface UseControllerBulkAction<PropsType, ColumnPropsType> {
  bulkActionColumnProps: ColumnPropsType
  bulkActionColumnTitle: string | null
  bulkActionSectionProps: PropsType
  controllersListUpdateInProgress: boolean
  onBulkActionUpdated: (controllerBulkAction: ControllerBulkAction | null) => void
}
